import { Model } from '@nozbe/watermelondb';

import {
    DBServiceOptionsWithImagesAndValidation,
    EntryDBServiceOptions,
} from '../../../../types/dbService';
import { EntryModel } from '../../../../types/Entries';
import { HorseContactModel } from '../../../../types/HorseContact';
import { HorseModel } from '../../../../types/Horses';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import Entry from '../../Entry';
import EventHorse from '../../EventHorse';
import HorseContact from '../../HorseContact';

export const prepareDeleteHorse = ({ horse }: { horse: HorseModel }) =>
    horse.prepareMarkAsDeleted();

export const prepareDeleteHorseContacts = async ({
    horseId,
    shouldDelete,
    serviceOptions,
}: {
    horseId: string;
    shouldDelete: boolean;
    serviceOptions: DBServiceOptionsWithImagesAndValidation;
}): Promise<HorseContactModel[]> => {
    if (!shouldDelete) return [];

    const horseContactService = new HorseContact(serviceOptions);
    const horseContacts = await horseContactService.getByParam(
        'horse_id',
        horseId,
    );

    return horseContacts.map((horseContact) =>
        horseContact.prepareMarkAsDeleted(),
    );
};

export const prepareDeleteEventHorses = async ({
    horseId,
    shouldDelete,
    serviceOptions,
}: {
    horseId: string;
    shouldDelete: boolean;
    serviceOptions: DBServiceOptionsWithImagesAndValidation;
}): Promise<Model[]> => {
    if (!shouldDelete) return [];

    const eventHorseService = new EventHorse(serviceOptions);
    const eventsHorse = await eventHorseService.getByParam('horse_id', horseId);

    return eventsHorse.map((eventHorse) => eventHorse.prepareMarkAsDeleted());
};

export const prepareDeleteEntries = async ({
    entries,
    userId,
    serviceOptions,
}: {
    entries: EntryModel[];
    userId: string;
    serviceOptions: EntryDBServiceOptions;
}): Promise<Model[]> => {
    if (entries.length === 0) return [];

    const entryService = new Entry(serviceOptions);
    const deleteBatches = await Promise.all(
        entries.map((entry) =>
            entryService.prepareDeleteById(entry.id, userId),
        ),
    );

    return deleteBatches.flatMap((batch) => batch);
};

export const logDeleteHorseActions = ({
    horse,
    horseContactsToDelete,
    logDBAction,
    tableName,
}: {
    horse: HorseModel;
    horseContactsToDelete: HorseContactModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete horse',
        modelName: tableName,
        payload: horse,
    });

    if (horseContactsToDelete.length > 0) {
        logDBAction({
            message: 'Delete horse - delete horse contacts',
            modelName: tableName,
            payload: horseContactsToDelete,
        });
    }
};
